<template>
  <div>
    <div class="banner">
      <h1>园区公告</h1>
    </div>
    <Card shadow :padding="40" class="notice-card">
      <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
      <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
      <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
      <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
      <div class="notice-content-wrap">
        <h1>{{data.title}}</h1>
        <p class="notice-time">发布日期: 【{{data.publishTime}}】</p>
        <div v-html='data.content'></div>
      </div>
    </Card>
  </div>
</template>

<script>
// import NoticeDetailJson from '../../../../mock/NoticeDetail.json'
import { httpAction } from '@/api/manage'
import api from '@/api'
export default {
  name: 'notice',
  data () {
    return {
      // NoticeDetailJson,
      data: []
    }
  },
  mounted () {
    const param = {
      id:this.$route.query.id
    }
    this.getNoticeDetail(param)
  },
  methods: {
    getNoticeDetail (param) {
      httpAction(api.noticeInfo, 'post', param).then(res => {
        this.data = res.data
      })
      this.data.publishTime = (this.data.publishTime && this.data.publishTime.length>10) ? this.data.publishTime.substring(0,10) : this.data.publishTime
      // this.data = NoticeDetailJson.data[param]
      // console.log(this.data)
    }
  }
}
</script>

<style scoped lang="less">
  .notice-card{
    margin: 220px auto 20px;
    width: 1000px;
    position: relative;
  }
  .notice-time{
    color: @time-color;
    margin-top: 20px;
  }
  .notice-content-wrap{
    text-align: center;
    padding: 0 80px;
  }
  .notice-content{
    text-align: left;
    font-size: 14px;
    padding-top: 40px;
  }
  .notice-content p {
    margin-bottom: 20px;
  }
  .notice-text{
    text-indent: 28px;
  }
  .notice-sign-up{
    text-align: right;
  }
  .banner{
    background-image: url("../../../../assets/banner_1.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1920px;
  }
</style>
